import api from '@app/application/client_meetings/screens/past-meetings/api'
import { defineStore } from 'pinia'
import { ref } from 'vue'
import { Meeting } from '@app/application/client_meetings/screens/past-meetings/utils/types'
import { SfLog } from '@app/adapters/logger'

export const createPastMeetingsStore = defineStore('pastMeetingsStore', () => {
  const meetings = ref<Meeting[]>([])

  async function fetchPastMeetings(): Promise<void> {
    try {
      const response = await api.getPastMeetings()
      if (response) {
        meetings.value = response
      } else {
        SfLog.error('Got empty response when fetching past meetings')
      }
    } catch (err) {
      SfLog.error('Failed to fetch past meetings', {
        extra: { error: err },
      })
    }
  }

  return {
    meetings,
    fetchPastMeetings,
  }
})
